import { frontendURL } from '../../../helper/URLHelper';
import { ROLES } from 'dashboard/constants/permissions.js';

import CetakersFlowOverview from './pages/Overview.vue';
import CetakersFlowSettings from './pages/Settings.vue';
import CetakersFlowRouteView from './pages/RouteView.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/cetakers_flow'),
      component: CetakersFlowRouteView,
      meta: {
        permissions: ['administrator'],
      },
      children: [
        {
          path: 'overview',
          name: 'cetakers_flow_overview',
          component: CetakersFlowOverview,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: 'settings',
          name: 'cetakers_flow_settings',
          component: CetakersFlowSettings,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: '',
          name: 'cetakers_flow_index',
          redirect: 'overview',
        },
      ],
    },
  ],
};
